import React, { useState, useEffect } from "react";
import GeneralLayout from "components/PageLayouts/GeneralLayout";
import DiscipleshipPathwayDetail from "./DiscipleshipPathway/DiscipleshipPathwayDetail";
import DiscipleshipPathwayBottomDrawer from "./DiscipleshipPathway/DiscipleshipPathwayBottomDrawer";
import { getDiscipleshipPathwayData } from "api/Community/DiscipleshipPathwayAPI";
import { DiscipleshipPathwayFlow } from "api/Community/CommunityInterfaces";

const DiscipleshipPathway: React.FC = () => {
  const [selectedNode, setSelectedNode] = useState<any | null>(null);
  const [discipleshipPathway, setDiscipleshipPathway] = useState<DiscipleshipPathwayFlow | null>(null);
  
  useEffect(() => {
    let mounted = true;
    getDiscipleshipPathwayData()
      .then((data) => {
        if (mounted) setDiscipleshipPathway(data);
      }) 
      .catch((err) => {
        // optionally handle error or set an error state
        console.error("Failed to load discipleship pathway:", err);
      });
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <GeneralLayout 
      useBottomDrawer
      bottomDrawerContent={
        <DiscipleshipPathwayBottomDrawer
          selectedNode={selectedNode}
        />
      }
    >
      <DiscipleshipPathwayDetail
        discipleshipPathway={discipleshipPathway}
        selectedNode={selectedNode}
        onNodeSelect={setSelectedNode}

      />
    </GeneralLayout>
  );
};

export default DiscipleshipPathway;
